import { render, staticRenderFns } from "./StepGuide.vue?vue&type=template&id=16904b45&"
import script from "./StepGuide.vue?vue&type=script&lang=js&"
export * from "./StepGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports